import React, { useMemo, useState } from "react";
import { CrewPilotModuleShell } from "../../CrewPilotModuleShell";
import {
  buildEstimateReportModel,
  exportEstimateReportPdf,
} from "../../../helpers/estimateReport";
import "../../desktop/deskKit.css";
import { PAGE_LAYOUT } from "../../../layout/pageLayout";
import { useIsDesktopViewport } from "../../../hooks/useIsDesktopViewport";
import { EstimateReportDocument } from "./EstimateReportDocument";
import {
  ReportPreviewChrome,
  ReportPreviewFrame,
} from "../../report/ReportPreviewChrome";
import { useOrganization } from "../../../context/OrganizationContext";
import { resolveOrgBranding } from "../../../helpers/resolveOrgBranding";

export function EstimateReportPreviewScreen({
  estimateTree,
  materialsCatalog,
  clientName,
  statusLabel,
  options,
  onBack,
  onEditOptions,
}) {
  const isDesktop = useIsDesktopViewport();
  const [pdfExporting, setPdfExporting] = useState(false);
  const { settings } = useOrganization();
  const branding = useMemo(() => resolveOrgBranding(settings), [settings]);

  const reportModel = useMemo(
    () =>
      buildEstimateReportModel(estimateTree, materialsCatalog, options, {
        clientName,
        statusLabel,
      }),
    [estimateTree, materialsCatalog, options, clientName, statusLabel],
  );

  async function handleExportPdf() {
    try {
      setPdfExporting(true);
      await exportEstimateReportPdf(reportModel, { branding });
    } catch (error) {
      console.error("Estimate PDF export failed:", error);
      window.alert("Could not export the PDF. Please try again.");
    } finally {
      setPdfExporting(false);
    }
  }

  return (
    <CrewPilotModuleShell
      title="Estimate Preview"
      subtitle={estimateTree?.estimate_number || estimateTree?.title || ""}
      sectionLabel="Estimate Report"
      onBack={onBack}
      desktopBackLabel="Estimate Summary"
      layout={isDesktop ? PAGE_LAYOUT.COMMAND : undefined}
      compact={isDesktop}
      headerActions={
        isDesktop ? (
          <div className="cdh-actions">
            {onEditOptions && (
              <button type="button" className="dt-btn" onClick={onEditOptions}>
                Edit Options
              </button>
            )}
            <button
              type="button"
              className="dt-btn dt-btn--primary"
              onClick={handleExportPdf}
              disabled={pdfExporting}
            >
              {pdfExporting ? "Exporting PDF…" : "Export PDF"}
            </button>
          </div>
        ) : undefined
      }
    >
      <ReportPreviewFrame>
        <EstimateReportDocument reportModel={reportModel} />
      </ReportPreviewFrame>

      {!isDesktop && (
      <ReportPreviewChrome>
        {onEditOptions && (
          <button type="button" className="nx-btn" onClick={onEditOptions}>
            Edit Options
          </button>
        )}
        <button
          type="button"
          className="nx-btn nx-btn-gold"
          onClick={handleExportPdf}
          disabled={pdfExporting}
        >
          {pdfExporting ? "Exporting PDF…" : "Export PDF"}
        </button>
      </ReportPreviewChrome>
      )}
    </CrewPilotModuleShell>
  );
}
